module.exports = __webpack_public_path__ + "static/img/中国版“迪士尼”.fc7c42c5.png";